import React, { memo } from 'react';
import type { Comment } from './CommentList.types';
import { Virtualizer } from '../../components/Virtualizer';
import { CommentCard } from '../../components/CommentCard';

interface CommentSectionProps {
  comments: Comment[];
  getCardPropsFor: (
    comment: Comment
  ) => React.ComponentProps<typeof CommentCard>;
  /** When false, comments are rendered without Virtualizer (e.g. when using Load More). Default true. */
  useVirtualizer?: boolean;
}

const CommentSectionComponent: React.FC<CommentSectionProps> = ({
  comments,
  getCardPropsFor,
  useVirtualizer = true
}) => {
  return (
    <>
      {comments.map(comment =>
        useVirtualizer ? (
          <Virtualizer key={comment.id} itemId={comment.id}>
            <CommentCard {...getCardPropsFor(comment)} />
          </Virtualizer>
        ) : (
          <CommentCard key={comment.id} {...getCardPropsFor(comment)} />
        )
      )}
    </>
  );
};

export const CommentSection = memo(CommentSectionComponent);
{
  /* <Virtualizer key={`${comment.id}-${comment.replies?.length || 0}`} itemId={`${comment.id}-${comment.replies?.length || 0}`}> */
}
